var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTratamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_1156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5H4V12.5H18V7.5Z",
    fill: "#053779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 31.5H0V3.5H22V12.5H20V5.5H2V29.5H20V25.5H22V31.5Z",
    fill: "#1680E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5H5V4.5H7V0.5Z",
    fill: "#1680E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H10V4.5H12V0.5Z",
    fill: "#1680E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0.5H15V4.5H17V0.5Z",
    fill: "#1680E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4601 23.86L14.9301 24.57L15.6401 21.04L27.6601 9.02002L30.4801 11.84L18.4601 23.86Z",
    fill: "#053779"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_1156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.49,
    height: 31,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTratamento);
export default __webpack_public_path__ + "static/media/tratamento.30a989a623a42bba6795e3ad2353973a.svg";
export { ForwardRef as ReactComponent };